/* eslint-disable */
export const Acl = (user, roles) => {
  if (user.length > 0) {
    return roles.some((role) => user.includes(role));
  }
};

export const getRoles = JSON.parse(localStorage.getItem('permissions'));
